import { Grid } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { MyButton } from "../../../components/my-button/MyButton";
import MyContext from "../../../contexts/MyContext";

export const Slide6 = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);
  const onContinue = () => {
    myContext.resetState();
    myContext.changeActiveSlide(0);
  };
  return (
    <MyContext.Consumer>
      {(context) => (
        <div hidden={context.activeSlide !== 5}>
          <Grid container spacing={3} style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
            <Grid item>
              <div dangerouslySetInnerHTML={{ __html: t("thank_you_for_your_application_marlartag") }} />
            </Grid>
            <Grid item>
              <MyButton className="margin top-0" text={t("submit_another_claim")} onClick={onContinue} />
            </Grid>
          </Grid>
        </div>
      )}
    </MyContext.Consumer>
  );
};
